import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
    * {
        box-sizing: border-box;
    }

    .hide-element-accessible {
        border: 0;
        clip: rect(1px 1px 1px 1px);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
    }

    html {
        height: 100%;
    }

    body  {
        height: 100%;
        margin: 0;
        font-smooth: always;
        font-size: 16px;
        -webkit-font-smoothing: antialiased;
        line-height: 1.35;
        font-family: ${({ theme }) => theme.fonts.primary};
    }

    h1, h2, h3, h4, h5, h6 {
        margin: 0;
    }

    button: {
        cursor: pointer;
    }

    a {
        text-decoration: none;
        color: inherit;
        /* border-radius: 4px; */
    }
`
